export default __webpack_public_path__ + "2e7551cfce3ef545a1db36a7dddf7dc8.jpg";